<template>
  <Wrapper :team="team">
    <div>
      <!-- Team plan section -->
      <div class="mt-10 divide-y divide-gray-200">
        <div class="space-y-1">
          <h3 class="text-lg leading-6 font-medium text-gray-900">
            Team plan
          </h3>
          <p class="max-w-2xl text-sm text-gray-500">
            Here you'll find your organisation's current plan and options for upgrading.
          </p>
        </div>
        <div class="mt-6">
          <div class="py-4 sm:py-5 sm:grid sm:grid-cols-3 sm:gap-4 sm:pt-5">
            <dt class="text-sm font-medium text-gray-500">
              Invoicing Module
            </dt>
            <dd class="mt-1 flex text-sm text-gray-900 sm:mt-0 sm:col-span-2 justify-end">
              <Switch
                v-model="form.invoicing"
                :class="form.invoicing ? 'bg-blue-600' : 'bg-gray-200'"
                class="relative inline-flex h-6 w-11 items-center rounded-full"
              >
                <span class="sr-only">Enable the Invoicing Module</span>
                <span
                  :class="form.invoicing ? 'translate-x-6' : 'translate-x-1'"
                  class="inline-block h-4 w-4 transform rounded-full bg-white transition"
                />
              </Switch>
            </dd>
            <dt class="text-sm font-medium text-gray-500">
              Tour Operator Module
            </dt>
            <dd class="mt-1 flex text-sm text-gray-900 sm:mt-0 sm:col-span-2 justify-end">
              <Switch
                v-model="form.operating"
                :class="form.operating ? 'bg-blue-600' : 'bg-gray-200'"
                class="relative inline-flex h-6 w-11 items-center rounded-full"
              >
                <span class="sr-only">Enable the Tour Operator Module</span>
                <span
                  :class="form.operating ? 'translate-x-6' : 'translate-x-1'"
                  class="inline-block h-4 w-4 transform rounded-full bg-white transition"
                />
              </Switch>
            </dd>
            <dt class="text-sm font-medium text-gray-500">
              Tour Guide Module
            </dt>
            <dd class="mt-1 flex text-sm text-gray-900 sm:mt-0 sm:col-span-2 justify-end">
              <Switch
                v-model="form.guiding"
                :class="form.guiding ? 'bg-blue-600' : 'bg-gray-200'"
                class="relative inline-flex h-6 w-11 items-center rounded-full"
              >
                <span class="sr-only">Enable the Tour Guide Module</span>
                <span
                  :class="form.guiding ? 'translate-x-6' : 'translate-x-1'"
                  class="inline-block h-4 w-4 transform rounded-full bg-white transition"
                />
              </Switch>
            </dd>
          </div>
        </div>
      </div>
      <!-- Team plan section end -->
    </div>
  </Wrapper>
</template>

<script>
import Wrapper from './Wrapper.vue';
import EditableField from '@/ComponentsDeprecated/EditableField.vue';
import { Switch } from '@headlessui/vue';
import { notify } from 'notiwind';
import Button from '@/Jetstream/Button.vue';

export default {
  components: {
    Button,
    Switch,
    EditableField,
    Wrapper,
  },
  props: {
    team: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      form: {
        invoicing: this.team.invoicing,
        operating: this.team.operating,
        guiding: this.team.guiding,
      }
    };
  },
  watch: {
    form: {
      handler() {
        this.updateTeam()
      },
      deep: true
    }
  },
  methods: {
    updateTeam() {
      axios.put(route('teams.update', this.team), this.form).then(() => {
        notify({
          type: 'success',
          title: 'Saved',
          text: 'Plan was updated!',
        }, 4000);
      }).catch((error) => {
        // notify user of error
        notify({
          type: 'danger',
          title: 'Something went wrong',
          text: 'Could not save plan. Please try again.',
        }, 4000);
        // log error
        console.error('save error: ', error);
      });
    }
  },
};
</script>

<style lang="scss" scoped>
// #RPT: remove when buttons are connected
button {
    color: lightgray;
    cursor: not-allowed;
}
</style>
